import { lazy, Suspense, type ComponentProps } from 'react';

const GameOverPanelImpl = lazy(() => import('./GameOverPanelImpl'));
type GameOverPanelProps = ComponentProps<typeof GameOverPanelImpl>;

/** Load progression/leaderboard/share UI only once a game has actually ended. */
export default function GameOverPanel(props: GameOverPanelProps) {
  return (
    <Suspense fallback={<div role="status">Loading results…</div>}>
      <GameOverPanelImpl {...props} />
    </Suspense>
  );
}
